// SEO CHECKPOINT 1 COMPLETE: SEOHead component created, index.html cleaned
// SEO CHECKPOINT 2 COMPLETE: SEOHead added to all pages, noIndex set on non-core booking + utility pages
// SEO CHECKPOINT 3 COMPLETE: Schema added, final review done
// OG IMAGE SET: default og-image-sons-island.jpg applied to all pages via SEOHead default prop
import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
  ogType?: string;
  noIndex?: boolean;
  schemaJson?: object | object[];
  keywords?: string;
  hreflang?: { lang: string; url: string }[];
}

const SEOHead = ({
  title,
  description,
  canonical,
  ogImage = "https://sonsisland.com/og-image-sons-island.jpg",
  ogType = "website",
  noIndex = false,
  schemaJson,
  keywords,
  hreflang,
}: SEOHeadProps) => {
  const alternates = hreflang ?? [
    { lang: "en", url: canonical },
    { lang: "x-default", url: canonical },
  ];
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />
      {alternates.map((a) => (
        <link key={a.lang} rel="alternate" hrefLang={a.lang} href={a.url} />
      ))}
      <meta name="robots" content={noIndex ? "noindex, nofollow" : "index, follow"} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Son's Island" />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemaJson && (
        <script type="application/ld+json">
          {JSON.stringify(schemaJson)}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
